import { provideState } from '@ngrx/store';

import { aliasesFeatureState } from './aliases';

export const FEATURES_STATES = [
  provideState(aliasesFeatureState)
] as const;
